// The underway item names the ACTIVITY being run, e.g. "Sending Email". The
// activity's own name (`activityLabel`) is shown as-is — a prior version
// guessed at stripping an auto-generated "{Kind} - {StageName}" suffix and
// wrongly truncated custom names that happened to match that shape (e.g.
// "Interview - Hired" → "Interview").

// Most automatable actions are "send"-style (email, review request,
// assessment invite, survey), so the default verb is "Send". Interviews are
// scheduled, not sent — hence "Schedule interview" (matches the design).
const VERB_BY_KIND: Record<string, string> = {
  interview: 'Schedule',
};

export const verbForKind = (kind: string | undefined): string =>
  (kind && VERB_BY_KIND[kind]) || 'Send';

// "email" + "Email - Application Review" → "Send Email - Application Review".
export const getActivityActionLabel = (
  kind: string | undefined,
  label: string
): string => `${verbForKind(kind)} ${label}`;
